export default __webpack_public_path__ + "static/media/shiffon.c8a88030.png";